export const SET_USER = 'SET_USER';

export const dispatchSetUser = (user)=> {
  return (dispatch) => {
    dispatch({type: SET_USER, user})
  }
}
